import { Google } from "@mui/icons-material";
import { GOOGLE_CLIENT_ID } from "../api/DefaultConfig";
import { loginGoogle } from "../api/authentication/login/GoogleLoginAPI";
import { useSnackbar } from "notistack";
import { AlertErrorProp } from "../components/SnackbarNoti";


export async function initializeGoogleClient() {
    async function handleCallbackResponse(response) {
        loginGoogle(response.credential).then((res) => {
            if (res["token"]) {
                localStorage.setItem("accessToken", res["token"]);
            }
            window.location.href = "/"
        }).catch((err) => {
        });
    }

    console.log("HELLO");
    /* global google */

    google.accounts.id.initialize({
        client_id: GOOGLE_CLIENT_ID,
        callback: handleCallbackResponse
    })

    google.accounts.id.renderButton(
        document.getElementById("google-signin-button"),
        { type: "standard", size: "large", shape: "rectangular", width: "280", logo_alignment: "left" }
    )
}